export default "__VITE_ASSET__4de66c5b__"